<template>
  <footer class="foot">
    <span>
      Complement IT SaaS
      © {{ year }} Todos los derechos reservados
    </span>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
    data: () => ({
      date: '',
      time: '',
      year: '',
      timestamp: '',
      fulldatetime: ''
    }),
    methods: {
      printDate: function () {
        return new Date().toLocaleDateString();
      },
      printTime: function () {
        return new Date().toLocaleTimeString();
      },
      printYear: function () {
        return new Date().getFullYear();
      },          
      printTimestamp: function () {
        return Date.now();
      },
      printFullDate: function(){
        return new Date();
      }
    },
    mounted: function () {
      this.date = this.printDate();
      this.time = this.printTime();
      this.timestamp = this.printTimestamp();
      this.year = this.printYear();
      this.fulldatetime = this.printFullDate();
    },
};
</script>

<style scoped>
.foot {
  text-align: center;
  font-size: 12px;
  color: #666;
  padding: 2px 0;
  line-height: 1.2;
  height: auto;
  min-height: 20px;
}
</style>